import {createContext, useContext} from 'react'

export const RoutePathContext = createContext<any>(undefined)

export const useRoutePath = () => {
  return useContext(RoutePathContext)
}
